import { render, staticRenderFns } from "./ClientIcon.vue?vue&type=template&id=38170617&"
import script from "./ClientIcon.vue?vue&type=script&lang=js&"
export * from "./ClientIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports